const FILIAL_TODAS = {
  ID: 9999,
  DESCRICAO: 'Todas',
}

export {
  FILIAL_TODAS
}
